import { Controller } from "@hotwired/stimulus"

import { initializeGapiClient, showGoogleDrivePicker } from "~/lib/google.js"

export default class extends Controller {
  connect() {
    if (window.location.hash === '#choose-folder') {
      initializeGapiClient(this.showPicker);
    }
  }

  showPicker() {
    showGoogleDrivePicker((args) => {
      if (args.action === 'picked') {
        const folderId = args.docs[0].id;
        const folderName = args.docs[0].name;

        const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

        fetch('/google/drive', {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(
            {
              authenticity_token: csrfToken,
              folder_id: folderId,
              folder_name: folderName,
            },
          ),
        }).then(() => {
          window.location.href = '/';
        });
      }
    });
  }
}
